export const CACHE = {
    time: {
        '1hr': 1000 * 60 * 60 * 1,
        '2hrs': 1000 * 60 * 60 * 2,
        '8hrs': 1000 * 60 * 60 * 8,
        '5mins': 1000 * 60 * 5,
    },
};
